module.exports = __webpack_public_path__ + "img/appBarMovile.a8eb8653.png";